import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import asyncComponent from "../../../util/asyncComponent";
import { DeniedState } from "../workflowOperations/components/SurfaceState";
import "../workflowOperations/workflowOperations.css";
import "./qualityControl.css";

const hasQualityControlAccess = (authUser) => authUser?.Claims?.includes("admin.access");

const QualityControl = ({ match }) => {
  const authUser = useSelector((state) => state.auth?.authUser || null);

  if (!hasQualityControlAccess(authUser)) {
    return (
      <div className="app-wrapper">
        <div className="workflow-ops-panel mt-3">
          <DeniedState reason="Quality Control is available to admin users only." />
        </div>
      </div>
    );
  }

  return (
    <div className="app-wrapper quality-control-route">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/overview`} />
        <Redirect exact from={match.url} to={`${match.url}/overview`} />
        <Route exact path={`${match.url}/overview`} component={asyncComponent(() => import("./routes/OverviewPage"))} />
        <Route exact path={`${match.url}/issue-groups/:issueGroupId`} component={asyncComponent(() => import("./routes/IssueGroupDetailPage"))} />
        <Route exact path={`${match.url}/operations/:operationId`} component={asyncComponent(() => import("./routes/OperationDetailPage"))} />
        <Route exact path={`${match.url}/agent-investigations/:investigationId`} component={asyncComponent(() => import("./routes/AgentInvestigationDetailPage"))} />
        <Route component={asyncComponent(() => import("app/routes/extraPages/routes/404"))} />
      </Switch>
    </div>
  );
};

export default QualityControl;
